import React, { FC, useState } from "react";
import { SelectDocumentModal } from "../../modals/SelectDocumentModal/SelectDocument";
import { t } from "i18next";
import { Document } from "../../../models";
import { downloadDocuments } from "../../../utils/download";
import Popup from "../../Popup/Popup";
import ErrorIcon from "../../../assets/Icons/svg/errorIcon";
import SuccessIcon from "../../../assets/Icons/svg/successIcon";

interface MultipleDownloadProps {
  isModalOpen: boolean;
  hideModal: () => void;
  showModal: () => void;
  selectedDocuments: Document[];
  setSelectedDocuments: React.Dispatch<React.SetStateAction<Document[]>>;
  documents?: Document[];
  icon?: React.ReactNode;
  warningTitle?: string;
  warningDescription?: string;
}

const MultipleDownloadModal: FC<MultipleDownloadProps> = (props) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadSuccess, setDownloadSuccess] = useState(false);
  const [downloadError, setDownloadError] = useState(false);

  const handleDownload = async () => {
    setIsDownloading(true);
    setDownloadSuccess(false);
    setDownloadError(false);

    try {
      const documents = [];
      
      if (!props?.selectedDocuments || props?.selectedDocuments?.length === 0) {
        return;
      }

      for (const document of props.selectedDocuments as any[]) {
        if (document?.id) {
          documents.push(document?.id);
        }
      }

      await downloadDocuments({
        documentIds: documents,
        onSuccess: () => {
          setDownloadSuccess(true);
        },
        onError: (error: any) => {
          setDownloadError(true);
        },
        onLoadingChange: (loading: boolean) => {
          setIsDownloading(loading);
        }
      });

      props?.setSelectedDocuments([]);
      props?.hideModal();
    } catch (error) {
      console.error("Error during multiple downloads:", error);
      setDownloadError(true);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      <SelectDocumentModal
        isModalOpen={props.isModalOpen}
        hideModal={props.hideModal}
        showModal={props.showModal}
        selectedDocuments={props.selectedDocuments}
        setSelectedDocuments={props.setSelectedDocuments}
        documents={props.documents}
        title={String(t("select_documents"))}
        actionButton={{
          text: isDownloading ? "Downloading..." : "Download",
          onClick: handleDownload,
          className: "downloadButton",
          disabled: isDownloading
        }}
        icon={props.icon}
        warningTitle={props.warningTitle}
        warningDescription={props.warningDescription}
      />

      <Popup 
        isOpen={downloadSuccess} 
        title="Download Complete" 
        iconName={<SuccessIcon />}
        contentTitle="Download Completed" 
        customContent=""
        content="The documents have been downloaded successfully." 
        buttons={[]} 
        onClose={() => setDownloadSuccess(false)}
      />

      <Popup 
        isOpen={downloadError} 
        title="Download Failed" 
        iconName={<ErrorIcon />}
        contentTitle="Download Failed" 
        customContent=""
        content="The documents have not been downloaded. Please try again." 
        buttons={[]} 
        onClose={() => setDownloadError(false)}
      />
    </>
  );
};

export default MultipleDownloadModal;
